// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__27mM7","inputWrap":"Table_inputWrap__2i75m","col":"Table_col__1_LhN","bmiTooltip":"Table_bmiTooltip__3Bn8I"};